import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=872906ea&scoped=true"
import script from "./memberCard.vue?vue&type=script&lang=js"
export * from "./memberCard.vue?vue&type=script&lang=js"
import style0 from "./memberCard.vue?vue&type=style&index=0&id=872906ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872906ea",
  null
  
)

export default component.exports